import React from 'react';
import { useNotification } from '../context/NotificationContext';
import { CheckCircleIcon, XCircleIcon, InformationCircleIcon, XMarkIcon } from '@heroicons/react/24/outline';

function GlobalNotification() {
  const { activeUINotification } = useNotification();

  if (!activeUINotification) {
    return null;
  }

  // Determine color scheme based on notification type
  let bgColor, textColor, icon;
  switch (activeUINotification.type) {
    case 'success':
      bgColor = 'bg-green-50';
      textColor = 'text-green-800';
      icon = <CheckCircleIcon className="h-5 w-5 text-green-400" aria-hidden="true" />;
      break;
    case 'error':
      bgColor = 'bg-red-50';
      textColor = 'text-red-800';
      icon = <XCircleIcon className="h-5 w-5 text-red-400" aria-hidden="true" />;
      break;
    case 'warning':
      bgColor = 'bg-yellow-50';
      textColor = 'text-yellow-800';
      icon = <InformationCircleIcon className="h-5 w-5 text-yellow-400" aria-hidden="true" />;
      break;
    case 'info':
    default:
      bgColor = 'bg-blue-50';
      textColor = 'text-blue-800';
      icon = <InformationCircleIcon className="h-5 w-5 text-blue-400" aria-hidden="true" />;
      break;
  }

  return (
    <div className="fixed top-4 right-4 z-50 max-w-md w-full shadow-lg rounded-lg overflow-hidden pointer-events-auto">
      <div className={`${bgColor} p-4`}>
        <div className="flex items-start">
          <div className="flex-shrink-0">{icon}</div>
          <div className="ml-3 w-0 flex-1 pt-0.5">
            <p className={`text-sm font-medium ${textColor}`}>{activeUINotification.message}</p>
          </div>
          <div className="ml-4 flex-shrink-0 flex">
            <button
              className={`inline-flex ${textColor} focus:outline-none focus:ring-2 focus:ring-offset-2`}
              onClick={() => {
                // This will be handled automatically by the timeout in NotificationContext
                // But we could add a close function to the context if needed
              }}
            >
              <span className="sr-only">Close</span>
              <XMarkIcon className="h-5 w-5" aria-hidden="true" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default GlobalNotification;
